import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { ModelHasLiability } from '/@/modules/contact/models/ModelHasLiability';
import { ModelHasLiabilityCategory } from '@/modules/contact/enums/ModelHasLiabilityCategory';

export class LiabilityCoOwner extends BaseEntityModel {
  id?: number;

  firstName?: string;

  middleName?: string;

  lastName?: string;

  type?: string;

  pivot: ModelHasLiability;

  constructor(model: Partial<LiabilityCoOwner> = {}) {
    super(model);

    this.id = model.id;
    this.firstName = model.firstName;
    this.middleName = model.middleName;
    this.lastName = model.lastName;
    this.type = model.type;
    this.pivot = ModelHasLiability.mapModel(model.pivot);
    this.pivot.category = this.pivot.category ?? ModelHasLiabilityCategory.CO_OWNER;
  }

  /**
   * @returns {?string}
   */
  get fullName(): string | null {
    return !!this.firstName || !!this.lastName
      ? [this.firstName, this.middleName, this.lastName].filter(Boolean).join(' ')
      : null;
  }

  setShareOfOwnership(value: number): void {
    this.pivot.shareOfOwnership = value;
  }
}
